import {onFind} from "@elements/init-modules-in-scope";
import {findAllIn, closest, on} from '@elements/dom-utils';
import asyncAppend from "@elements/async-append";
import axios from "axios";
import {resultTracking} from "@elements/tracking";

const selectors = {
    base: '.js-cart-entries',

    cartItem: '.js-cart-entries__item',
    cartBtn: '.js-cart-entries__btn',

    target: '.js-cart-entries__result',
    loading: '.js-cart-entries__loading',
};

export function init () {
    onFind(selectors.base, function (el) {
        onFind(selectors.cartItem, function (cartItem) {
            let cartBtns = findAllIn(selectors.cartBtn, cartItem);
            let baseElement = closest(selectors.base, cartItem);
            let cartEntriesURL = baseElement.dataset.cartEntriesUrl;

            cartBtns.map(function(cartBtn) {
                on('click', function (evt) {
                    evt.preventDefault();

                    let data = {
                        action: "remove",
                        id: cartBtn.dataset.id,
                    };

                    if (cartEntriesURL) {
                        loadContent(baseElement, cartEntriesURL, data, 'POST');
                    } else {
                        console.warn("cart-entries.js: no cartURL is set");
                    }
                }, cartBtn);
            });
        })
    });

    function loadContent(baseElement, url, data, method) {

        let pendingRequest = null;
        if (method === 'GET') {
            pendingRequest = axios({method: 'GET', url: url, params: data});
        } else {
            pendingRequest = axios({method: 'POST', url: url, data: data});
        }

        let results = findAllIn(selectors.target, baseElement);
        let targetsByResultId = {};

        results.forEach((element) => {
            let resultId = element.dataset.cartEntriesResultId;
            if (targetsByResultId[resultId]) {
                targetsByResultId[resultId] = [...targetsByResultId[resultId], element];
            } else {
                targetsByResultId[resultId] = [element];
            }
        });

        asyncAppend({
            target: targetsByResultId,
            loading: findAllIn(selectors.loading, baseElement),
        }, pendingRequest.then((x) => x.data)).then((result) => {
            if(result.cartSum) {
                if(document.getElementsByClassName('js-cart-counter')[0]) {
                    document.getElementsByClassName('js-cart-counter')[0].innerHTML = result.cartSum;
                }
            }

            // execute resultTracking
            // data contains and executes _trackingScript
            if(result.responseTrackingData && window._trackingData) {
                window.dataLayer = window['dataLayer'] || [];
                window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                resultTracking(result);
            }
        });
    }
}
